<template>
  <div class="access-control-container">
    <el-row :gutter="20">
      <el-col :span="4">
        <select-admin-community @changeCommunity="handleCommunityChange" />
      </el-col>
      <el-col :span="20">
        <el-card class="box-card">
          <div slot="header"><span>{{ $t('aAccessControl.search.title') }}</span></div>
          <el-row :gutter="12">
            <el-col :span="5">
              <el-input v-model="searchForm.deviceId" :placeholder="$t('aAccessControl.search.deviceId')" clearable />
            </el-col>
            <el-col :span="5">
              <el-input v-model="searchForm.serialNo" :placeholder="$t('aAccessControl.search.serialNo')" clearable />
            </el-col>
            <el-col :span="5">
              <el-input v-model="searchForm.machineName" :placeholder="$t('aAccessControl.search.machineName')" clearable />
            </el-col>
            <el-col :span="4">
              <el-select v-model="searchForm.bindState" :placeholder="$t('aAccessControl.search.bindState')" clearable>
                <el-option value="1000" :label="$t('aAccessControl.state.pending')" />
                <el-option value="1100" :label="$t('aAccessControl.state.bound')" />
                <el-option value="1200" :label="$t('aAccessControl.state.conflict')" />
              </el-select>
            </el-col>
            <el-col :span="5">
              <el-button type="primary" @click="handleSearch">{{ $t('common.search') }}</el-button>
            </el-col>
          </el-row>
        </el-card>

        <el-card class="box-card list-card">
          <div slot="header"><span>{{ $t('aAccessControl.list.title') }}</span></div>
          <el-table v-loading="loading" :data="tableData" border>
            <el-table-column prop="communityName" :label="$t('aAccessControl.table.communityName')" min-width="150" />
            <el-table-column prop="deviceId" :label="$t('aAccessControl.table.deviceId')" min-width="150" />
            <el-table-column prop="serialNo" :label="$t('aAccessControl.table.serialNo')" min-width="180" />
            <el-table-column prop="machineName" :label="$t('aAccessControl.table.machineName')" min-width="130">
              <template slot-scope="scope">{{ scope.row.machineName || '-' }}</template>
            </el-table-column>
            <el-table-column :label="$t('aAccessControl.table.bindState')" width="110" align="center">
              <template slot-scope="scope">
                <el-tag :type="bindTag(scope.row.bindState)">{{ bindText(scope.row.bindState) }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column :label="$t('aAccessControl.table.online')" width="90" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.online === 'Y' ? 'success' : 'info'">
                  {{ scope.row.online === 'Y' ? $t('aAccessControl.online.yes') : $t('aAccessControl.online.no') }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="firstOnlineTime" :label="$t('aAccessControl.table.firstOnlineTime')" min-width="160" />
            <el-table-column prop="lastOnlineTime" :label="$t('aAccessControl.table.lastOnlineTime')" min-width="160" />
            <el-table-column prop="conflictReason" :label="$t('aAccessControl.table.conflictReason')" min-width="220">
              <template slot-scope="scope">{{ scope.row.conflictReason || '-' }}</template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page.sync="pagination.current"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pagination.size"
            :total="pagination.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listAdminAccessControl } from '@/api/iot/aAccessControlApi'
import SelectAdminCommunity from '@/components/community/selectAdminCommunity'

export default {
  name: 'AAccessControlList',
  components: { SelectAdminCommunity },
  data() {
    return {
      loading: false,
      searchForm: { deviceId: '', serialNo: '', machineName: '', bindState: '', communityId: '' },
      tableData: [],
      pagination: { current: 1, size: 10, total: 0 }
    }
  },
  created() { this.getList() },
  methods: {
    async getList() {
      this.loading = true
      try {
        const result = await listAdminAccessControl({
          ...this.searchForm,
          page: this.pagination.current,
          row: this.pagination.size
        })
        this.tableData = result.data || []
        this.pagination.total = result.total || 0
      } catch (error) {
        this.$message.error(error.message || this.$t('aAccessControl.fetchError'))
      } finally {
        this.loading = false
      }
    },
    bindText(state) {
      const keys = { '1000': 'pending', '1100': 'bound', '1200': 'conflict', '1300': 'disabled' }
      return this.$t('aAccessControl.state.' + (keys[state] || 'unknown'))
    },
    bindTag(state) {
      return { '1000': 'warning', '1100': 'success', '1200': 'danger', '1300': 'info' }[state] || 'info'
    },
    handleSearch() { this.pagination.current = 1; this.getList() },
    handleSizeChange(size) { this.pagination.size = size; this.getList() },
    handleCurrentChange(page) { this.pagination.current = page; this.getList() },
    handleCommunityChange(community) {
      this.searchForm.communityId = community.communityId
      this.handleSearch()
    }
  }
}
</script>

<style lang="scss" scoped>
.access-control-container {
  padding: 20px;
  .list-card { margin-top: 20px; }
  .el-pagination { margin-top: 20px; text-align: right; }
}
</style>
